import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Linkify from 'react-linkify'
import reactStringReplace from 'react-string-replace'
import { formatName, formatDate, getOriginalFileName, Auth } from '../../../helpers'
import { displayAlert, socketSendMessage } from '../../../actions'

import emoji from 'node-emoji'
import { Emoji } from 'emoji-mart'
import { emojiNative } from './emojiNative'
import 'emoji-mart/css/emoji-mart.css'

class ChatMessage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      mouseOver: false,
      editing: false,
      text: '',
      textAreaHeight: ''
    }

    this.renderOptions = this.renderOptions.bind(this)
    this.handleEditMsg = this.handleEditMsg.bind(this)
    this.handlePinMsg = this.handlePinMsg.bind(this)
    this.handleUnpinMsg = this.handleUnpinMsg.bind(this)
  }

  componentDidMount () {
    if (this.props.pinned && this.props.index === 0) {
      this.props.setParentHeight(this.refs[this.props.msg._id].clientHeight)
    }
    const textHeight = this.refs['text'] && this.refs['text'].clientHeight
    this.setState({ textAreaHeight: textHeight + textHeight / 17 * 2 + 'px' })
  }

  handleEditMsg () {
    if (this.state.text === this.props.msg.text) {
      this.props.dispatch(displayAlert('There is no change to save.'))
      return
    }

    const action = 'edit_message'
    const data = {
      msg: this.props.msg,
      text: this.state.text
    }

    this.props.dispatch(socketSendMessage({ action, data }))
  }

  handleUnpinMsg () {
    const action = 'edit_message'
    const data = {
      msg: this.props.msg,
      text: this.props.msg.text,
      pinned: false
    }

    this.props.dispatch(socketSendMessage({ action, data }))
  }

  handlePinMsg () {
    const action = 'edit_message'
    const data = {
      msg: this.props.msg,
      text: this.props.msg.text,
      pinned: true
    }

    this.props.dispatch(socketSendMessage({ action, data }))
  }

  renderFileMessage (text) {
    switch (this.isFileLoadable(text)) {
      case 'image':
        return (
          <a href={text} target='_blank' className='file-msg image-wrap'>
            <img alt='file' src={text} className='file-img image-message' />
          </a>
        )
      case 'video':
        return (
          <video width='320' height='240' controls className='file-img image-message'>
            <source src={text} />
            Your browser does not support the video tag.
          </video>
        )
      case 'default':
        return (
          <a href={text} target='_blank' className='file-msg'>
            <img alt='file' src='/imgs/Asset16.png' className='file-img' />
            <div className='red'>{getOriginalFileName(text).slice(-40)}</div>
          </a>
        )
      default:
        return (
          <a href={text} target='_blank' className='file-msg'>
            <img alt='file' src='/imgs/Asset16.png' className='file-img' />
            <div className='red'>{getOriginalFileName(text).slice(-40)}</div>
          </a>
        )
    }
  }

  highlightHandleTags (text) {
    let result = reactStringReplace(text, this.props.handle, (match, i) => (
      <span className='red' key={i}>{match}</span>
    ))

    result = reactStringReplace(result, '@@all', (match, i) => (
      <span className='red' key={i}>{match}</span>
    ))

    const usedEmojis = emojiNative
      .filter(emj => text.includes(emj))
      .map(emj => emoji.find(emj))
      .filter(emj => emj !== undefined)

    usedEmojis.forEach(emj => {
      result = reactStringReplace(result, emj.emoji, (match, i) => (
        <Emoji emoji={{ id: emj.key }} size={16} key={i} />
      ))
    })

    result = reactStringReplace(result, '\n', (match, i) => (
      <br key={i} />
    ))

    return result
  }

  isFileLoadable (url) {
    const imgTypes = ['bmp', 'jpg', 'jpeg', 'png', 'git']
    const videoTypes = ['mp4', 'mov']

    let ext = url.split('.').pop().toLowerCase()

    if (imgTypes.indexOf(ext) !== -1) {
      return 'image'
    }

    if (videoTypes.indexOf(ext) !== -1) {
      return 'video'
    }

    return 'default'
  }

  renderOptions () {
    const { msg, pinned } = this.props
    if (pinned) return

    if (this.props.msg.from === Auth.getParticipant() && Auth.isAdmin() && !msg.isFile && !msg.pinned) {
      return (
        <span className='edit-bttn-container'>
          <img
            onClick={() => this.setState({ editing: true, text: msg.text })}
            alt='EDIT MESSAGE'
            src='/imgs/pencil.png'
            className='message-edit-bttn cursor-pointer' />
          <img
            onClick={this.handlePinMsg}
            alt='PIN MESSAGE'
            src='/imgs/pin.png'
            className='message-edit-bttn cursor-pointer' />
        </span>
      )
    }

    if (Auth.isAdmin() && !msg.pinned) {
      return (
        <span className='edit-bttn-container'>
          <img
            key='1'
            onClick={this.handlePinMsg}
            alt='PIN MESSAGE'
            src='/imgs/pin.png'
            className='message-edit-bttn cursor-pointer' />
        </span>
      )
    }

    if (this.props.msg.from === Auth.getParticipant() && !msg.isFile) {
      return (
        <span className='edit-bttn-container'>
          <img
            onClick={() => this.setState({ editing: true, text: msg.text })}
            alt='EDIT MESSAGE'
            src='/imgs/pencil.png'
            className='message-edit-bttn cursor-pointer' />
        </span>
      )
    }
  }

  componentWillReceiveProps (nextProps) {
    nextProps.msg.text !== this.props.msg.text && this.setState({ editing: false })
  }

  render () {
    const { msg, pinned } = this.props
    const sender = this.props.players.find(p => p.id === msg.from)
    const pinner = this.props.players.find(p => p.id === msg.pinnedBy)
    if (sender) {
      return (
        <div
          ref={msg._id}
          key={msg._id}
          id={msg._id}
          className={`row ${((msg.text.includes(this.props.handle) || msg.text.includes('@@all')) && !pinned) && 'mentioned'}`}
          onClick={() => this.setState({ mouseOver: !this.state.mouseOver })}
          onMouseEnter={() => this.setState({ mouseOver: true })}
          onMouseLeave={() => this.setState({ mouseOver: false })}>
          {pinned &&
            <div className='pinned-info'>
              <img alt='' src='/imgs/pinned.png' width={15} height={15} />
              pinned by {pinner && pinner.handle}
              {Auth.isAdmin() && <span onClick={this.handleUnpinMsg}>✖</span>}
            </div>
          }
          <div className={`cell-photo ${pinned && 'pin-space'}`}>
            <div className='user-photo'
              style={{ background: `url(${sender.avatar || '/imgs/default-avatar.png'}) no-repeat center /cover` }} />
          </div>
          <div className={`cell-name ${pinned && 'pin-space'}`} style={{ width: '100%' }}>
            <div className='user-name'>
              {formatName(sender.name)} <Link
                className='color-inherit'
                to={`/player/${sender.id}`}>
                {sender.handle}
              </Link>
              {this.state.mouseOver && !this.state.editing && this.renderOptions()}
            </div>
            <div className='excerpt' ref='text'>
              {(!this.state.editing && !msg.isFile) &&
                <Linkify
                  properties={{
                    target: '_blank',
                    style: { color: '#c53622', display: 'block', width: 'calc(100vw - 110px)', maxWidth: '300px', wordWrap: 'break-word' }
                  }}>
                  {this.highlightHandleTags(msg.text)}
                </Linkify>
              }
              {this.state.editing &&
                [
                  <textarea
                    key='0'
                    className='edit-msg-container'
                    style={{ height: this.state.textAreaHeight }}
                    value={this.state.text}
                    onChange={ev => this.setState({ text: ev.target.value, textAreaHeight: ev.target.clientHeight })} />,
                  <button
                    key='1'
                    onClick={this.handleEditMsg}
                    className='button button-sm'>done</button>,
                  <button
                    key='2'
                    onClick={() => this.setState({ editing: false })}
                    className='button button-sm link-form-bttn'>cancel</button>
                ]
              }
              {msg.isFile && (
                <div className='file-msg'>
                  {this.renderFileMessage(msg.text)}
                </div>
              )}
            </div>
          </div>
          <div className={`cell-date ${pinned && 'pin-space'}`}>
            {formatDate(msg.createdAt)}
          </div>
        </div>
      )
    } else {
      return (
        <div
          ref={msg._id}
          key={msg._id}
          id={msg._id}
          className='row'>
          <div className='cell-photo'>
            <div className='user-photo'
              style={{ background: `url('/imgs/default-avatar.png') no-repeat center /cover` }} />
          </div>
          <div className='cell-name' style={{ width: '100%' }}>
            <div className='user-name'>
              Unknown
            </div>
            <div className='excerpt'>
              {'<< You should reload the page to see this message. >>'}
            </div>
          </div>
          <div className='cell-date'>
            {formatDate(msg.createdAt)}
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    handle: state.auth.user.handle,
    players: state.participants
  }
}

export default connect(mapStateToProps)(ChatMessage)



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/ChatMessage.js